"use client";

/**
 * PwaRegister — registra o service worker (instalabilidade + base pro
 * Web Push). Sem UI; roda uma vez no mount do root layout.
 */
import { useEffect } from "react";

export default function PwaRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Sem SW (browser antigo / permissão) o app continua funcionando
      // normalmente — só perde instalação rica e push.
    });
  }, []);
  return null;
}
